import { FC, useCallback } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { DialogTitle, Typography } from "@mui/material";
import {
  resetAccountSetup,
  setAccountSetupDialogType,
} from "../../../../../../store/account-setup/accountSetupSlice";
import { useAppDispatch, useAppSelector } from "../../../../../../store/hooks";
import { pollingSelector } from "../../../../../../store/account-setup/selectors/pollingSelector";
import { accountAttemptSelector } from "../../../../../../store/account-setup/selectors/accountAttemptSelector";
import { currentStepSelector } from "../../../../../../store/account-setup/selectors/currentStepSelector";

export const MissingSubAccountRoleDialogTitle: FC = () => {
  const currentStep = useAppSelector(currentStepSelector);
  const accountAttempt = useAppSelector(accountAttemptSelector);
  const polling = useAppSelector(pollingSelector);
  const dispatch = useAppDispatch();

  const showCloseButton =
    accountAttempt?.status === "failed" || currentStep === 0 || !polling;

  const handleCloseDialog = useCallback(() => {
    dispatch(setAccountSetupDialogType(null));
    dispatch(resetAccountSetup());
  }, [dispatch]);

  return (
    <DialogTitle>
      <Typography variant="body1" fontWeight="medium">
        Add Cloudchipr Role
      </Typography>
      {showCloseButton && (
        <IconButton
          onClick={handleCloseDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </DialogTitle>
  );
};
